"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _notice = require("@/api/basic/notice");
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 你要根据接口路径改
var _default = exports.default = {
  name: 'notice',
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增公告',
      searchForm: {
        type: null,
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      dialogForm: {
        id: null,
        content: '',
        type: null,
        sort: 0,
        iconUrl: '',
        linkType: null,
        linkUrl: ''
      },
      fileList: [],
      resPath: process.env.VUE_APP_IMAGE_PATH
    };
  },
  methods: {
    fetchList: function fetchList() {
      var _this = this;
      this.loading = true;
      (0, _notice.getNoticeList)(this.searchForm).then(function (res) {
        _this.tableData = res.records || [];
        _this.searchForm.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    getResPathInfo: function getResPathInfo() {
      var _this2 = this;
      (0, _upgradeStrategy.getResPath)().then(function (res) {
        _this2.resPath = res.data;
      });
    },
    resetForm: function resetForm() {
      this.searchForm.type = null;
      this.searchForm.page = 1;
      this.searchForm.limit = 10;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    },
    openDialog: function openDialog(row) {
      if (row) {
        this.dialogTitle = '编辑公告';
        this.dialogForm = _objectSpread({}, row);
        this.fileList = row.iconUrl ? [{
          name: '图标',
          url: this.resPath + row.iconUrl
        }] : [];
      } else {
        this.dialogTitle = '新增公告';
        this.resetDialogForm();
      }
      this.dialogVisible = true;
    },
    resetDialogForm: function resetDialogForm() {
      this.dialogForm = {
        id: null,
        content: '',
        type: null,
        sort: 0,
        iconUrl: '',
        linkType: null,
        linkUrl: ''
      };
      this.fileList = [];
      if (this.$refs.dialogFormRef) this.$refs.dialogFormRef.clearValidate();
      this.dialogVisible = false;
    },
    saveNotice: function saveNotice() {
      var _this3 = this;
      // 校验...
      if (!this.dialogForm.content || this.dialogForm.type === null) {
        this.$message.error('请完整填写内容和类型');
        return;
      }
      (0, _notice.saveNotice)(this.dialogForm).then(function () {
        _this3.$message.success('保存成功');
        _this3.dialogVisible = false;
        _this3.fetchList();
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$confirm('确认删除该公告吗？', '提示', {
        type: 'warning'
      }).then(function () {
        (0, _notice.deleteNotice)(row.id).then(function () {
          _this4.$message.success('删除成功');
          _this4.fetchList();
        });
      });
    },
    handleUploadRemove: function handleUploadRemove(file) {
      this.dialogForm.iconUrl = '';
      this.fileList = [];
    },
    handlePictureUploadOne: function handlePictureUploadOne(_ref) {
      var _this5 = this;
      var file = _ref.file;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('path', "/notice/");
      (0, _notice.uploadPhoto)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        // 更新展示地址
        _this5.dialogForm.iconUrl = url;

        // 替换上传组件的 fileList（最多一张）
        _this5.fileList = [{
          name: '展示图',
          url: _this5.resPath + url
        }];
        _this5.$message.success('上传成功');
      }).catch(function () {
        _this5.$message.error('上传失败');
      });
    },
    typeFormatter: function typeFormatter(row, column, cellValue) {
      if (cellValue === 0) return '会员中心公告';
      if (cellValue === 1) return '任务规则';
      if (cellValue === 2) return '积分抵扣规则';
      if (cellValue === 3) return '券膨胀规则';
      if (cellValue === 4) return '小红书活动规则';
      if (cellValue === 5) return '客诉券券发放规则';
      if (cellValue === 6) return '客诉券券领取规则';
      return '-';
    }
  },
  mounted: function mounted() {
    this.getResPathInfo();
    this.fetchList();
  }
};